import { Box, Modal, Typography, useMediaQuery, useTheme } from '@mui/material';

import { pxToRem, pxTovW } from '../../../commonUtils/resizeUtils';
import { IStyles } from '../../../commonUtils/styleUtils';
import ImageWrapper from '../../elements/ImageWrapper';
import getDeviceType from 'libs/shared-ui/src/commonUtils/getDeviceType';

const classAndSubjectBoxStyle = {
  // border: '1px solid red',
  borderWidth: { md: '0.052vw' }, //10px
  borderStyle: { md: 'solid' },
  borderColor: { md: 'neutral.gainsboro' },
  borderRadius: { md: '0.521vw' }, //10px
  boxShadow: '0px 0px 0.573vw rgba(231, 231, 231, 0.85)',
  '&:hover': {
    boxShadow: '0px 0px 0.573vw grey',
  },

  width: { md: pxTovW(300), lg: pxTovW(180) },
  height: { md: pxTovW(250), lg: pxTovW(160) },
  display: { md: 'flex' },
  flexDirection: { md: 'column' },
  justifyContent: { md: 'center' },
  alignItems: 'center',
  cursor: 'pointer',
  pl: { xs: pxToRem(20), md: '0' },
};

const styles: IStyles = {
  modal: {
    boxSizing: 'border-box',
    display: { xs: 'flex', md: 'flex' },
    alignItems: { xs: 'flex-end', md: 'center' },
  },

  root: {
    backgroundColor: 'common.white',
    overflowY: 'auto',
    margin: { md: 'auto' },
    width: { xs: '100%', md: pxTovW(1000), lg: pxTovW(650) },
    height: { xs: pxToRem(437), md: 'max-content' },
    maxHeight: { xs: pxToRem(437), md: '35.156vw', lg: '25.156vw' },
    borderRadius: { xs: `${pxToRem(30)} ${pxToRem(30)} 0 0`, md: pxToRem(15) },
    // paddingY: pxToRem(22),
    paddingX: { md: pxToRem(40), lg: pxToRem(22) },
    // mt: { md: '30vh' },
  },

  headingBox: {
    // border: '1px solid green',
    display: 'flex',
    justifyContent: 'space-between',
    paddingX: { xs: pxToRem(22), md: 0 },
    paddingBottom: { xs: pxToRem(15), md: pxTovW(23) },
    width: { xs: '90%', md: pxTovW(1000), lg: pxTovW(650) },
    position: 'fixed',
    background: '#FFFFFF',
    paddingTop: { xs: pxToRem(22), md: pxTovW(24) },
    borderRadius: { xs: `${pxToRem(30)} ${pxToRem(30)} 0 0`, md: 0 },
  },
  closeBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  close: {
    width: { xs: pxToRem(13) },
    height: { xs: pxToRem(13) },
    alignItems: 'center',
    cursor: 'pointer',
  },

  displayDataMapper: {
    // display: { md: 'flex' },
    // flexWrap: { md: 'wrap' },
    // gap: { md: '0.521vw' }, //10px
    mt: { md: '1.042vw' }, //20px
    display: { md: 'grid' },
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridGap: { xs: pxToRem(12), md: pxTovW(12) },
    paddingX: { md: pxTovW(15), lg: pxTovW(10) },
    paddingTop: { xs: pxToRem(60), md: pxTovW(90), lg: pxTovW(60) },
    paddingBottom: { xs: pxToRem(10), md: pxTovW(20) },
  },
  classAndSubjectBox: classAndSubjectBoxStyle,
  subjectBox: {
    width: '100%',
    height: '100%',
    p: { xs: `${pxToRem(10)} 0`, md: `${pxTovW(10)}` },
    boxSizing: 'border-box',
    display: 'flex',
    // flexDirection: { xs: 'row', md: 'column' },
    justifyContent: { xs: 'flex-start', md: 'space-around' },
    flexWrap: { md: 'wrap' },
    alignItems: 'center',
    gap: { xs: pxToRem(11), md: pxToRem(5), lg: pxToRem(11) },
    borderTopWidth: { xs: '0.052vw' },
    borderTopStyle: { xs: 'solid', md: 'none' },
    borderTopColor: { xs: 'neutral.aqua' },
  },
  subjectIcon: {
    width: { xs: pxToRem(36), lg: pxTovW(57) },
    height: { xs: pxToRem(36), lg: pxTovW(57) },
  },
};

//* Interface
interface IProps {
  title?: string;
  modalState: boolean;
  setModalState: (arg: boolean) => void;
  displayData: {
    subject: string;
    icon: string;
    onClick?: () => void;
    color: string;
    disabled?: boolean;
  }[];
}
export const StudentSubjectPopup = ({
  title,
  modalState,
  setModalState,
  displayData,
}: IProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const android = window.Android;
  const deviceType = getDeviceType();
  return (
    <Modal
      open={modalState}
      onClose={() => {
        setModalState(false);
        try {
          if (deviceType === 'android' && android?.enableAppRefresh) {
            console.log('enableAppRefresh called');
            android.enableAppRefresh();
          }
        } catch (error) {
          console.log(
            'An error occurred while attempting to enable app refresh on Android:'
          );
        }
      }}
      sx={styles.modal}
    >
      <Box sx={styles.root}>
        <Box sx={styles.headingBox}>
          <Typography variant={isMobile ? 'h2' : 'h3'} fontWeight="medium">
            {title || 'Choose Subject'}
          </Typography>

          <Box
            onClick={(e) => {
              setModalState(false);
              try {
                if (deviceType === 'android' && android?.enableAppRefresh) {
                  console.log('enableAppRefresh');
                  android.enableAppRefresh();
                }
              } catch (error) {
                console.log(
                  'An error occurred while attempting to enable app refresh on Android:'
                );
              }
            }}
            sx={styles.closeBox}
          >
            <ImageWrapper
              name="close"
              type="png"
              parentFolder="icons"
              styles={styles.close}
            />
          </Box>
        </Box>

        <Box sx={styles.displayDataMapper}>
          {displayData.map((elem, index) => (
            <Box
              key={index}
              sx={{
                ...classAndSubjectBoxStyle,
                ...(elem.disabled
                  ? {
                      opacity: 0.5,
                      filter: 'grayscale(1)',
                      cursor: 'not-allowed',
                      '&:hover': {
                        boxShadow: '0px 0px 0.573vw rgba(231, 231, 231, 0.85)',
                      },
                    }
                  : {}),
              }}
              onClick={() => {
                if (elem.disabled) {
                  return;
                }
                elem?.onClick && elem.onClick();
                try {
                  if (deviceType === 'android' && android?.enableAppRefresh) {
                    console.log('enableAppRefresh');
                    android.enableAppRefresh();
                  }
                } catch (error) {
                  console.log(
                    'An error occurred while attempting to enable app refresh on Android:'
                  );
                }
              }}
            >
              <Box
                sx={{
                  ...styles.subjectBox,
                  overflow: 'auto',
                }}
              >
                {elem.icon.startsWith('http') ? (
                  <Box>
                    <ImageWrapper
                      name={'subjects/' + elem.subject?.toLowerCase() || ''}
                      type="png"
                      parentFolder="icons"
                      styles={styles.subjectIcon}
                      path={
                        elem.icon.startsWith('http') ? elem.icon : undefined
                      }
                    />
                  </Box>
                ) : (
                  <Box
                    sx={{
                      ...styles.subjectIcon,
                      border: `1px solid ${elem.color || '#000000'}`,
                      backgroundColor: `${elem.color || '#000000'}33`,
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <Typography
                      variant="h2"
                      color={elem.color || '#000000'}
                      sx={{ fontWeight: 900 }}
                    >
                      {elem.subject ? elem.subject[0] : ''}
                    </Typography>
                  </Box>
                )}
                <Box
                  sx={{
                    width: '100%',
                  }}
                >
                  <Typography
                    variant="cardText"
                    sx={{
                      width: 'max-content',
                      maxWidth: '100%',
                      fontFamily: 'poppins',
                      textAlign: 'center',
                      marginX: { md: 'auto' },
                      // backgroundColor: 'red',
                      // textOverflow: 'ellipsis',
                      whiteSpace: 'wrap',
                      display: '-webkit-box',
                      WebkitLineClamp: 3,
                      // WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                      wordWrap: 'break-word',
                    }}
                  >
                    {elem.subject}
                  </Typography>
                </Box>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Modal>
  );
};

const subjectColor: { [key: string]: string } = {
  english: 'primary',
  maths: 'warning.main',
  marathi: 'neutral.royalBlue',
  science: 'secondary',
};
